import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export default function PageHero({ eyebrow, title, subtitle, image }) {
  return (
    <section className="relative pt-[74px] bg-lp-blue text-white overflow-hidden">
      {image && (
        <div className="absolute inset-0">
          <img src={image} alt="" className="w-full h-full object-cover opacity-25" />
          <div className="absolute inset-0 bg-lp-blue/70" />
        </div>
      )}
      <div className="container-lp relative py-20 lg:py-28">
        {eyebrow && (
          <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.1 }} className="eyebrow mb-4">
            {eyebrow}
          </motion.p>
        )}
        <motion.h1
          initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, ease: EASE }}
          className="font-heading font-700 text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight max-w-4xl"
        >
          {title}
        </motion.h1>
        {subtitle && (
          <motion.p
            initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.2, duration: 0.7 }}
            className="mt-6 text-white/80 text-lg max-w-2xl leading-relaxed"
          >
            {subtitle}
          </motion.p>
        )}
      </div>
    </section>
  );
}
